import Vue from 'vue'
import SudokuMachineOption from './sudokuMachine.vue'

const SudokuMachine = Vue.extend(SudokuMachineOption)

export function templateSudokuMachineVue({ module, postMessage, callModule }) {
  const sudokuMachine = new SudokuMachine({
    propsData: {
      module
    },
    methods: {
      postMessage,
      callModule
    }
  }).$mount()
  return sudokuMachine.$el
}
